angular.module('inspinia').directive('baseRadio', () => {
  return {
    restrict: 'E',
    scope: {
      type: '@',
      name: '@',
      ngDisabled: '=?',
      ngChecked: '@',
      value: '@',
      ngValue: '@',
      ngModel: '=',
      onClick: '&',
    },
    transclude: true,
    templateUrl: `/manage/src/view/directive/base_radio.html?${new Date().getTime()}`,
    link: ($scope) => {
      $scope.ngDisabled || false;

      /**
       * ラジオボタンの種別
       */
      const baseRadioType = () => {
        $scope.inputType = '';
        $scope.labelType = '';

        const prefix = 'anglrC-radio_';
        if ($scope.type === 'alert') {
          $scope.inputType = `${prefix}input--alert`;
          $scope.labelType = `${prefix}label--alert`;
        } else if ($scope.ngDisabled) {
          $scope.inputType = `${prefix}input--disabled`;
          $scope.labelType = `${prefix}label--disabled`;
        }
      };
      baseRadioType();

      /**
       * クリックイベントの発火
       */
      $scope.onClickBaseRadio = () => {
        if (!$scope.ngDisabled) $scope.onClick();
      };

      /**
       * ng-disabledを監視して、クラスを動的に変更する
       */
      $scope.$watch('ngDisabled', (newVal, oldVal) => {
        if (newVal !== oldVal) {
          $scope.ngDisabled = newVal;
          baseRadioType();
        }
      });
    },
  };
});
